import layout, { layoutVariants, type LayoutVariantsType } from './layout';
import color, { colorVariants, type ColorVariantsType } from './color';
import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const logoSection = {
  color,
  layout,
};

export const logoSectionVariants = {
  color: colorVariants,
  layout: layoutVariants,
};

export type LogoSectionComponentsType = 'color' | 'layout';
export interface LogoSectionType {
  /** The LogoSection subcomponent types. */
  SubComponents: {
    [K in LogoSectionComponentsType]: Product.VariantKeyModes<
      K extends 'color' ? ColorVariantsType : K extends 'layout' ? LayoutVariantsType : never
    >;
  };
  /** The LogoSection Color types. */
  Color: CustomTheme.VariantKeys<ColorVariantsType>;
  /** The LogoSection Layout types. */
  Layout: CustomTheme.VariantKeys<LayoutVariantsType>;
}

export default logoSection;
